<div class="c-guide-popover" *ngIf="vm.isOpen">
    <div class="c-guide-popover__container">
        <button type="button" class="c-guide-popover__close" id="closePopUpInfoButton" (click)="vm.handleCloseButtonClick()">
            <i class="o-icon o-icon--x" aria-hidden="true"></i>
            <span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
        </button>
        <p class="c-text" style="margin-bottom: 8px">
            {{'Employees.Guide_Info' | translate}}
        </p>
    </div>
</div>
